import {
  GET_STAFF_LEAVE_TYPE,
  GET_STAFF_LEAVE_TYPE_SUCCESS,
  GET_STAFF_LEAVE_TYPE_ERROR,
  GET_STAFF_LEAVE_LIST,
  GET_STAFF_LEAVE_LIST_SUCCESS,
  GET_STAFF_LEAVE_LIST_ERROR,
} from "./actionType";

// Reducer Calendar Staff Leave List and Staff Leave Type

const initialState = {
  staffLeaveList: [],
  staffLeaveType: [],
};

const CalendarCrmIT = (state = initialState, action) => {
  switch (action.type) {
    case GET_STAFF_LEAVE_LIST:
      return {
        ...state,
      };
    case GET_STAFF_LEAVE_LIST_SUCCESS:
      return {
        ...state,
        staffLeaveList: action.payload,
      };
    case GET_STAFF_LEAVE_LIST_ERROR:
      return {
        ...state,
      };
    case GET_STAFF_LEAVE_TYPE:
      return {
        ...state,
      };
    case GET_STAFF_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        staffLeaveType: action.payload,
      };
    case GET_STAFF_LEAVE_TYPE_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default CalendarCrmIT;
